import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../config';
import styles from './ThreePRank.module.less';
import SoftCardPRank from '../../components/SoftCardPRank/SoftCardPRank';
import { cleanSearchRecommend } from '../../actions/search';
import { logging, logPostInfo } from '../../actions/log';
import bg1 from '../../static/rank_bg1.png';
import bg2 from '../../static/rank_bg2.png';
import bg3 from '../../static/rank_bg3.png';
import bg4 from '../../static/rank_bg1.png';
import bg5 from '../../static/rank_bg2.png';
import bg6 from '../../static/rank_bg3.png';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(cardData => {
  const { data, logInfo } = cardData;
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const showSize = 5;

  const BgImg = { 0: bg1, 1: bg2, 2: bg3, 3: bg4, 4: bg5, 5: bg6 };
  const LOG_ACTION_SOURCE = {
    c_more: `${logInfo.tag}_Rank_More`,
    source: `${logInfo.tag}_Rank`,
    source_app: `${logInfo.tag}_Rank`,
  };
  const [ref, inView] = useInView({
    threshold: 1,
  });
  const [refDom, inViewDom] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      // let { pageCardContentId } = data && data.dataList && data.dataList[0];
      if (data && data.dataList && data.dataList.length > 1) {
        data.dataList.forEach(item => {
          logInfo.changView({
            pageCardId: item.pageCardContentId,
            pageCardTitle: data && data.title,
            rankCode: item.code,
            cardType: data && data.cardType,
            org: item.org,
          });
        });
      }
    }
  }, [inView]);

  const handleShowMore = useCallback(
    rankData => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_more,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${rankData.pageCardContentId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(`${CONTEXT}/rankmore?code=${rankData.code}`);
      dispatch(cleanSearchRecommend());
    },
    [dispatch, logInfoData],
  );

  return (
    data.dataList &&
    data.dataList.length > 2 && (
      <div
        className={inViewDom ? styles.card_cardIn : styles.card_cardOut}
        ref={ref}
        data-item={data.cardType}
      >
        <div className={styles.card} ref={refDom}>
          {inViewDom &&
            data.dataList.slice(0, 6).map((item, index) => {
              return (
                <div className={styles.card_column} key={index}>
                  <div className={styles.card_header_img_box}>
                    <img className={styles.card_header_img} src={item.imgUrl || BgImg[index]} />
                  </div>
                  <div className={`${styles.card_header} ${styles.card_header1}`}>
                    <div className={styles.card_header_title}>{item.name}</div>
                    {item.apps.length > 5 && (
                      <div
                        className={styles.card_header_more}
                        onClick={() => {
                          handleShowMore(item);
                        }}
                      >
                        更多
                      </div>
                    )}
                  </div>
                  <div className={styles.content_column}>
                    {item.apps.slice(0, showSize).map((soft, i) => (
                      <SoftCardPRank
                        soft={{ ...soft, cardShowDesc: true }}
                        logInfo={{
                          ...logInfo,
                          source: `${LOG_ACTION_SOURCE.source_app}||${item.pageCardContentId}`,
                        }}
                        key={i}
                        index={i + 1}
                      />
                    ))}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    )
  );
});
